import webBackApi from '../../api/webBackApi';

const API_PATH = "/api/video";

export const getLatestVideo = async (cameraId) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/latest/${cameraId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching latest video for camera ${cameraId}:`, error);
    throw error;
  }
};

export const getVideoStatus = async (jobId) => {
  try {
    const response = await webBackApi.get(`${API_PATH}/status/${jobId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching video status for job ${jobId}:`, error);
    throw error;
  }
};

export const getLatestS3Image = async (feedId) => {
  try {
    const response = await webBackApi.get(`/api/s3-images/${feedId}/latest`);
    return response.data;
  } catch (error) {
    console.error("Error fetching latest S3 image:", error);
    throw error;
  }
};
